import { compose, defaultProps } from 'recompose';
import { connect } from 'react-redux';
import { createCustomPageProps } from '../../helpers/utils';
import { getPartnerTrustCard } from '../../helpers/marketplace';
import { getCustomPage } from '../../store/reducers/content';
import { sendStatus } from '../../store/reducers/status-data';
import { getFAQ } from '../../store/reducers/faq';
import { setEditButton, setHelpButton } from '../../store/reducers/navigation';
import { toggleModal } from '../../store/reducers/modals';
import { getMarketplacePartners } from '../../store/reducers/marketplace';
import { withLoader } from '../../components/with-loader';
import { withContainer } from './with-container';
import { withSections } from './sections';

const defaultCurrentPage = {
  widget: {},
  meta: {},
  content: {},
  faq: {},
  coachie: {},
  trustCard: {},
  legalFooter: {},
  editButton: { display: false },
  helpButton: { display: false },
  statusMapping: {},
  type: ''
};

const mapStateToProps = (state, ownProps) => {
  const pageName = createCustomPageProps(ownProps.location.pathname).full;
  const currentPage = state.content.customPages[pageName] ?? defaultCurrentPage;
  const pathname = ownProps.location.pathname;
  const headerButtons = state.navigation.headerButtons;
  const faqName = state.content.customPages[pageName]?.faq.name;
  const normalizedPartners = state.marketplace?.normalizedPartners ?? {};
  const plainStatuses = state.statusData.plainStatuses;

  return {
    pageName,
    currentPage,
    statuses: state.statusData.parsedStatuses,
    statusesPlain: state.statusData.statuses,
    faqs: state.faq.questions[faqName],
    trustCard: getPartnerTrustCard(normalizedPartners, currentPage.trustCard.name),
    editButtonHeader: headerButtons.editButton[pathname],
    helpButtonHeader: headerButtons.helpButton[pathname],
    promotions: state.userAttributes.consents && state.userAttributes.consents.promotions,
    userAttributes: state.userAttributes,
    plainStatuses
  };
};

export const withCustomPage = widgets =>
  compose(
    defaultProps({
      widgets
    }),
    connect(mapStateToProps, {
      getCustomPage,
      sendStatus,
      getFAQ,
      setEditButton,
      setHelpButton,
      toggleModal,
      getMarketplacePartners
    }),
    withContainer,
    withSections,
    withLoader
  );
